import { Icon } from '@/components/ui/icon';
import { brandifyJncquoi } from '@/lib/core';

export interface InfoItem {
  icon?: string;
  text: string;
}

export interface BookingDetailInfoProps {
  rows: InfoItem[][];
}

export function BookingDetailInfo({ rows }: BookingDetailInfoProps) {
  const visibleRows = rows.filter(row => row.length > 0);
  if (visibleRows.length === 0) return null;

  return (
    <div className="flex w-full flex-col items-center gap-4">
      {visibleRows.map((row, i) => (
        <div key={i} className="flex flex-wrap items-center justify-center gap-4">
          {row.map((item, j) => (
            <div key={j} className="flex flex-wrap items-center justify-center gap-2">
              {item.icon && <Icon name={item.icon} width={20} height={20} className="text-white" />}
              <span className="font-pp-neue-montreal text-center text-base font-medium tracking-[0.5px] text-white">
                {brandifyJncquoi(item.text)}
              </span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
